import React from 'react';
import PropTypes from 'prop-types';
import { CaptionText, Alert } from '@paypalcorp/pp-react';
import getContent from 'pp-react-l10n';

const getRecurringInfoContent = getContent('locals')(
  'common/recurring-checkbox'
);

export default function RecurringInfo({ orgName, amount }) {
  return (
    <Alert type="info" className="recurring-info">
      <CaptionText className="line1"></CaptionText>
      {getRecurringInfoContent(
        'rp.helpText1',
        { orgName: orgName, amount: amount },
        { useHTML: true }
      )}
      <CaptionText className="line2">
        {getRecurringInfoContent('rp.helpText2')}
      </CaptionText>
    </Alert>
  );
}

RecurringInfo.propTypes = {
  orgName: PropTypes.string,
  amount: PropTypes.string,
};
